export default __webpack_public_path__ + "static/media/bedOverview-min.2565654d.jpg";